import React from "react";
import { Steps } from "antd";

const steps = [
  {
    title: "Personal",
    content: "personal-content",
  },
  {
    title: "Official",
    content: "official-content",
  },
  {
    title: "Salary",
    content: "Salary-content",
  },
  {
    title: "Time Off",
    content: "time off content",
  },
  // {
  //   title: "Docs",
  //   content: "docs-content",
  // },
  {
    title: "Dependents",
    content: "dependents-content",
  },
  {
    title: "Attendance",
    content: "attendance-content",
  },
];

const App = ({ current }) => {
  const items = steps.map((item) => ({ key: item.title, title: item.title }));

  return (
    <>
      <Steps
        current={current}
        style={{ fontSize: "4px" }}
        items={items}
        size="small"
        className="!text-md text-red-500"
      />
    </>
  );
};

export default App;
